import { render } from "./ServicesCatalog.vue?vue&type=template&id=0cb1e856"
import script from "./ServicesCatalog.vue?vue&type=script&lang=js"
export * from "./ServicesCatalog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__